import { BRAND_LUXE_ERROR, BRAND_LUXE_SECONDARY } from '../../../../pages/BrandDashboard/brandDashboardTokens';
import { pulseDot } from './submissionObsidianShared';

export { pulseDot };

/** Compact card footer pill — theme secondary / error tokens. */
export const inviteStatusCompactVisual = (accepted: boolean) => {
    if (accepted) {
        return {
            label: 'Accepted',
            bg: 'rgba(0, 253, 193, 0.05)',
            color: BRAND_LUXE_SECONDARY,
            border: 'rgba(0, 253, 193, 0.2)',
            dot: BRAND_LUXE_SECONDARY,
            pulse: true,
        };
    }
    return {
        label: 'Pending',
        bg: 'rgba(255, 115, 81, 0.08)',
        color: BRAND_LUXE_ERROR,
        border: 'rgba(255, 115, 81, 0.25)',
        dot: BRAND_LUXE_ERROR,
        pulse: true,
    };
};

export const inviteStatusVisual = (accepted: boolean) => {
    if (accepted) {
        return {
            label: 'Accepted',
            bg: 'rgba(20, 83, 45, 0.2)',
            color: '#4ade80',
            border: 'rgba(34, 197, 94, 0.2)',
            dot: '#22c55e',
            pulse: false,
        };
    }
    return {
        label: 'Pending',
        bg: 'rgba(127, 29, 29, 0.2)',
        color: '#f87171',
        border: 'rgba(239, 68, 68, 0.2)',
        dot: '#ef4444',
        pulse: true,
    };
};
